import { Button, cn } from '@bridebook/aura';
import { RsvpDeleteButton } from '@bridebook/web/components/wedding-website/rsvp/shared/rsvp-delete-button';
import { getScreenType } from '@bridebook/web/lib/app/selectors';
import { useUnifiedEvents } from '@bridebook/web/lib/events/use-unified-events';
import { useDeleteQuestion } from '@bridebook/web/lib/rsvp/hooks/use-delete-question';
import { useEventOptionsWithHandlers } from '@bridebook/web/lib/rsvp/hooks/use-event-options-with-handlers';
import { RsvpQuestionFormValues } from '@bridebook/web/lib/rsvp/types';
import { useSelector } from '@bridebook/web/lib/utils';
import { useTranslation } from 'next-i18next';
import { useFormContext } from 'react-hook-form';
import { useRsvpModal } from '@bridebook/web/components/wedding-website/rsvp/rsvp-modal.context';

interface IProps {
  questionId?: string;
}

export const FormControls = ({ questionId }: IProps) => {
  const { t } = useTranslation('weddingWebsite');
  const { unifiedEvents, isLoading: isUnifiedEventsLoading } = useUnifiedEvents();
  const isNewEntry = !questionId || questionId === 'add';
  const { isDesktop } = useSelector(getScreenType);

  const { setRsvpQuestionId } = useRsvpModal();

  const {
    setValue,
    getValues,
    formState: { isSubmitting },
  } = useFormContext<RsvpQuestionFormValues>();

  const { eventOptions } = useEventOptionsWithHandlers({
    isLoading: isUnifiedEventsLoading,
    unifiedEvents,
    getValues,
    setValue,
  });

  const handleDelete = useDeleteQuestion({
    questionId,
    onBack: () => setRsvpQuestionId(undefined),
  });

  const hasEvents = eventOptions.length > 0;

  return (
    <>
      {!isNewEntry &&
        (isDesktop ? (
          <RsvpDeleteButton
            onConfirm={handleDelete}
            size="standard"
            icon={undefined}
            className="min-w-[140px]">
            {t('weddingDetails.cta.delete')}
          </RsvpDeleteButton>
        ) : (
          <RsvpDeleteButton onConfirm={handleDelete} size="standard" />
        ))}
      <Button
        className={cn(
          'flex-1',
          isDesktop && !isNewEntry && 'max-w-[140px]',
          isDesktop && isNewEntry && 'max-w-[343px]',
        )}
        type="submit"
        loading={isSubmitting}
        disabled={!hasEvents}>
        {t('weddingDetails.cta.done')}
      </Button>
    </>
  );
};
